import type { IncomingMessage } from 'node:http'

export const getHeaderValue = (value?: string | string[]): string | undefined =>
  Array.isArray(value) ? value[0] : value

export interface RequestHostInfo {
  host?: string
  forwardedProtocol?: string
}

export const getRequestHostInfo = (req?: IncomingMessage | null): RequestHostInfo => {
  if (!req) return {}

  const forwardedHost = getHeaderValue(req.headers?.['x-forwarded-host'])
  const rawHost = getHeaderValue(req.headers?.host)
  const forwardedProtocol = getHeaderValue(req.headers?.['x-forwarded-proto'])

  return {
    host: forwardedHost || rawHost || undefined,
    forwardedProtocol: forwardedProtocol || undefined,
  }
}

export const buildBaseUrlFromHost = (
  host?: string,
  forwardedProtocol?: string | null,
): string | undefined => {
  if (!host) return undefined

  const normalizedHost = host.replace(/\/+$/, '')
  const hostHasProtocol = /^https?:\/\//i.test(normalizedHost)
  const protocol =
    forwardedProtocol ||
    (normalizedHost.includes('localhost') || normalizedHost.includes('127.0.0.1')
      ? 'http'
      : 'https')

  return hostHasProtocol ? normalizedHost : `${protocol}://${normalizedHost}`
}

export const isCustomDomainRequest = (
  req?: IncomingMessage | null,
  predicate?: (host?: string) => boolean,
): boolean => {
  const { host } = getRequestHostInfo(req)
  return predicate ? predicate(host) : Boolean(host)
}
